export default "__VITE_ASSET__CFKmPI_P__"